import { render, staticRenderFns } from "./DCOPreviewItem.vue?vue&type=template&id=55fa9dae&scoped=true"
import script from "./DCOPreviewItem.vue?vue&type=script&lang=js"
export * from "./DCOPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./DCOPreviewItem.vue?vue&type=style&index=0&id=55fa9dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa9dae",
  null
  
)

export default component.exports